// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3mObx","logoWrapper":"Header_logoWrapper__2iNon","headerLogo":"Header_headerLogo__iyTur","counter":"Header_counter__3PELT","button":"Header_button__3Lscu"};